function getQueryParameter(paramName) {
  const pageQuery = window.location.search.slice(1);
  const queryPairs = pageQuery.split('&');
  for (let i = 0; i < queryPairs.length; i++) {
    const [key, value] = queryPairs[i].split('=');
    if (key === paramName) {
      return value;
    }
  }
  return null;
}

function App() {
  const customerEmail = getQueryParameter('email');
  const customerSessionSecret = getQueryParameter('customer_session_secret');

  return (
    <stripe-pricing-table
      pricing-table-id="prctbl_1SSdaJLnDNgD9SJvQ097ENmi"
      publishable-key="pk_test_51SSdE4LnDNgD9SJvM2b2d2pqNDFEKNL0JVSZDmXzIY1B09X8a4OPms9K6u4mbtC62tmntGNQROnzTc6YDOlRVoKC005JbhTdWr"
      customer-email={customerEmail}
      customer-session-client-secret={customerSessionSecret}
    >
    </stripe-pricing-table>
  );
}

export default App;
